var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.response.default.type === 'CUSTOM')?_c('Custom',{attrs:{"item":_vm.response.default.payload,"is-single":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }